import { watchSteps } from "@/mocks/site";
import SectionHeading from "@/components/base/SectionHeading";

export default function StepsSection() {
  return (
    <section id="guide" className="w-full px-4 md:px-10 py-16 md:py-24">
      <SectionHeading
        eyebrow="围观姿势"
        title="正确吃瓜的四步，一次学会"
        desc="从锁定瓜线到理性收瓜，我们把围观流程拆成了四个动作，照着做就不会被热搜牵着走。"
        align="center"
      />

      <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
        {watchSteps.map((item, index) => (
          <div
            key={item.step}
            className="relative flex flex-col p-6 rounded-lg bg-background-50 border border-background-200"
          >
            <span className="font-hand text-5xl text-accent-500/70 leading-none">{item.step}</span>
            <span className="mt-4 w-11 h-11 rounded-lg bg-primary-100 text-primary-700 flex items-center justify-center text-xl">
              <i className={`${item.icon} w-6 h-6 flex items-center justify-center`}></i>
            </span>
            <h3 className="mt-4 text-base font-semibold text-foreground-950">{item.title}</h3>
            <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
            {index < watchSteps.length - 1 ? (
              <i className="hidden lg:flex absolute top-1/2 -right-3.5 ri-arrow-right-line w-6 h-6 items-center justify-center text-background-400"></i>
            ) : null}
          </div>
        ))}
      </div>
    </section>
  );
}